import { ACTIVITY_TYPES } from "../store/constant";

export const mapActivityType = (key, isObject = false) => {
  const activity = ACTIVITY_TYPES.find((a) => a.key === key);
  return isObject ? activity : activity?.name;
};
